import Vue from 'vue'
import AuthService from './auth.service'
/**
 * 医师服务管理
 */
export default {
    /**
     * 登录
     * @param {*} params
     * @param {*} config
     */
    async loginDoctor(params = {}, config = {}) {
        let result = await Vue.http.post('/DoctorInfo/LoginDoctor', params, config);
        return result;
    },
    /**
     * 通过医师编号获取医师信息
     * @param {*} params
     * @param {*} config
     */
    async getDoctorByID(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.get('/DoctorInfo/GetDoctorByID', config);
        return result;
    },
    /**
     * 根据医师编号获取挂职医院
     * @param {*} params
     * @param {*} config
     */
    async getHospitalByDoctorID(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.get('/DoctorInfo/GetHospitalByDoctorID', config);
        return result;
    },
    /**
     * 获取医生列表
     * @param {*} params
     * @param {*} config
     */
    async getDoctorInfolList(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.get('/DoctorInfo/GetDoctorInfolList', config);
        return result;
    },
    /**
     * 更新医师
     * @param {*} [params={}]
     * @param {*} [config={}]
     * @returns
     */
    async updateDoctor(params = {}, config = {}) {
        AuthService.getToken();
        let result = await Vue.http.put('/DoctorInfo/UpdateDoctorInfo', params, config);
        return result;
    },
    /**
     * 更新医师密码
     * @param {*} params 
     * @param {*} config 
     */
    async updatePassword(params = {}, config = {}) {
        AuthService.getToken();
        let result = await Vue.http.put('/DoctorInfo/UpdatePassword', params, config);
        return result;
    },
    /**
     * 医师注册
     * @param {*} params 
     * @param {*} config 
     */
    async registerDoctorInfo(params = {}, config = {}) {
        let result = await Vue.http.post('/DoctorInfo/RegisterDoctorInfo', params, config);
        return result;
    },
    /**
     * 用户登录忘记密码修改
     * @param {*} params 
     * @param {*} config 
     */
    async forgetPassword(params = {}, config = {}) {
        let result = await Vue.http.put('/DoctorInfo/ForgetPassword', params, config);
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/_services/doctor.service.js